import { useQuery } from 'data-fetching-client';
import { GET_ACCESS_CONTROLS_QUERY } from '../../../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService.dfc';
export function useAiAccessControls() {
  return useQuery(GET_ACCESS_CONTROLS_QUERY);
}